import React, { useEffect, useState } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance'
import {faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PeopleList({unit, setSelectedUnit, editing, setEditing, shouldUpdate}) {
    const [people, setPeople] = useState([])
    
    const fetchData = async () => {
        const response = await axiosInstance(`/admin/people/${unit._id}`)
        if(response.data.status){
            setPeople(response.data.data)
        };
    }

    useEffect(() => {
        fetchData()
    }, [shouldUpdate])

    const deletePerson = async (id) => {
        const response = await axiosInstance.delete(`/admin/people/${id}`)
        if(response.data.status){
            fetchData()
        }
    }

    return (
     
    <div className='w-full border-collapse border border-gray-500 mt-0 text-sm'>
          <div className='w-full border-b border-gray-500 grid grid-cols-12 gap-2 p-3'>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Անուն/Ազգանուն/Հայրանուն</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Զինկոչում</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Ծննդյան տարեթիվ</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Պաշտոն</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Ստորաբաժանում</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Զորակոչ</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Զինկոմիսարիատ</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Հասցե</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Առանձնահատուկ</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Զենքի տեսակը</p>
            </div>
            <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Զենքի համարը</p>
            </div>
            <div className= 'flex items-center gap-1 w-full p-1'>
                <p className='break-words w-full'>Ղեկավարման կոճակներ</p>
            </div>
        </div>
        {people.map((person) => (
                <div className='w-full border-gray-500 grid grid-cols-12 gap-2 p-3' key={person._id}>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.full_name}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.rang} {person.type === "haveTo" ? "" : "(Պ)"}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{new Date(person.birthday).toLocaleDateString()}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.position}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.battalion.battalion_number + " " + person.battalion.battalion_name + " " + person.company.company_number + " " + person.platoon.platoon_number}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.conscription}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.mil_commissariat}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.address}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.special}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.weapon}</p>
                    </div>
                    <div className='border-r border-gray-500 flex items-center gap-1 w-full p-1'>
                        <p className='break-words w-full'>{person.weapon_number}</p>
                    </div>
                    <div className='flex items-center gap-1 w-full p-1'>
                        <p className='p1 flex items-center justify-center w-full'>
                            <FontAwesomeIcon icon={faPenToSquare} className='mr-4 cursor-pointer' onClick={() => {setEditing(person); setSelectedUnit(unit)}} />
                            <FontAwesomeIcon icon={faTrash} className='cursor-pointer' onClick={() => deletePerson(person._id)}/>
                        </p>
                    </div>
                </div>
        ))}
    </div>
  )
}
